import PropTypes from "prop-types";
import React from "react";
import { NavLoader } from "ui/loader";
import { Table, Column } from "ui/table";
import { DEFAULT_TIME_FORMAT_WITH_TZ, utcToLocalFormat } from "util/time";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

import { formatTargets, formatStrategy } from "./utils";

class DeploymentListPage extends React.PureComponent {
  static get propTypes() {
    return {
      deployments: PropTypes.array.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
    };
  }

  constructor() {
    super();

    this.tableOpts = {
      sortName: "deploy_date",
      sortOrder: "desc",
    };
    this.formatDeployDate = (utcTime) => {
      return utcToLocalFormat(utcTime, DEFAULT_TIME_FORMAT_WITH_TZ);
    };
    this._formatTargets = formatTargets.bind(this);
  }

  _renderView() {
    const { deployments, storesLoaded } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    return (
      <Table
        data={deployments}
        hover={true}
        options={this.tableOpts}
        pagination={true}
        search={true}
      >
        <Column
          key="id"
          dataField="id"
          dataSort={true}
          width="300px"
          isKey={true}
          hidden={true}
        >
          ID
        </Column>
        <Column
          key="strategy"
          dataField="strategy"
          dataSort={true}
          dataFormat={formatStrategy}
        >
          Strategy
        </Column>
        <Column key="device_count" dataField="device_count" dataSort={true}>
          # of Devices
        </Column>
        <Column
          key="targets"
          dataField="targets"
          dataSort={false}
          dataFormat={this._formatTargets}
        >
          Targets
        </Column>
        <Column
          key="deploy_date"
          dataField="deploy_date"
          dataSort={true}
          dataFormat={this.formatDeployDate}
        >
          Deploy Date
        </Column>
      </Table>
    );
  }

  render() {
    return (
      <Page title="Past Deployments">
        <Box title="" noHeader={true}>
          {this._renderView()}
        </Box>
      </Page>
    );
  }
}

export { DeploymentListPage };
